export default val => (Array.isArray(val) ? val : [val])
